import { useMemo, useState } from 'react';

export const DESKTOP_WIDTH_LIMIT = 960;
export const TABLET_WIDTH_LIMIT = 600;

export const useScreen = () => {
  const [size, setSize] = useState<any>();

  window.addEventListener('orientationchange', () => {
    setSize({ update: true });
  });

  const isDesktop = useMemo(() => window.screen.width > DESKTOP_WIDTH_LIMIT, [size]);

  const isTablet = useMemo(
    () => window.screen.width <= DESKTOP_WIDTH_LIMIT && window.screen.width >= TABLET_WIDTH_LIMIT,
    [size]
  );

  const isMobile = useMemo(() => window.screen.width < TABLET_WIDTH_LIMIT, [size]);

  const width = useMemo(() => window.screen.width, [size]);

  return {
    isDesktop,
    isMobile,
    isTablet,
    width,
  };
};
